import React from 'react';
import PropTypes from 'prop-types';

export const optional = (required) => {
  if (required === false) {
    return <small>(optional)</small>;
  }
  return null;
};

/**
 * Input label
 * @deprecated
 * @returns {*}
 */
export const label = function() {
  if (this.props.label) {
    return (
      <label htmlFor={this.props.a11yFormLabels ? this.props.id : undefined}>
        {this.props.label} {optional(this.props.required)}
      </label>
    );
  }
  return null;
};

export const Label = ({ text, name, required }) => {
  if (text) {
    return (
      <label htmlFor={name}>
        {name} {optional(required)}
      </label>
    );
  }
  return null;
};

Label.propTypes = {
  text: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
};

export const describedById = (props) =>
  props.a11yFormLabels && props.helpBlockText && props.id
    ? `${props.id}-help`
    : undefined;

/**
 * Help block text
 * @returns {*}
 */
export const helpBlock = function() {
  if (this.props.helpBlockText) {
    return (
      <div className="help-block" id={describedById(this.props)}>
        {this.props.helpBlockText}
      </div>
    );
  }
  return null;
};

export const HelpBlock = ({ text }) => {
  if (text) {
    return <div className="help-block">{text}</div>;
  }
  return null;
};

HelpBlock.propTypes = {
  text: PropTypes.string,
};

HelpBlock.defaultProps = {
  text: null,
};
